import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FloatingLabel,
  Button,
  FormControl,
  Dropdown,
  ListGroup,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import {
  setCaseTypeName,
} from "../../../../redux/slice/CaseHeaderSlice";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import { fetchPickListByGroupName } from "../../../../services/UserRegistrationApi";
import {
  CASE_STAGE_STATUS,
  PARTY_TYPES,
  PICKLIST_GROUP_NAME,
  STAKEHOLDER_LIST_CODE,
  WEB_ROLE,
} from "../../../../common/Constant";
import TextInput from "../../../../common/TextInput";
import {
  addCaseSubject,
  addCaseSubjectAddress,
  fetchEmployerAddress,
  fetchEmployerContact,
  fetchEmployerGroup,
  fetchSubjectInfo,
  GetSubjectAddressList,
  updateCaseSubject,
  updateCaseSubjectAddress,
  searchCaseSubjectByText,
  createCaseFromSubject,
} from "../../../../services/Case_SubjectAPI";
import StakeholderCardDetails from "../../../../common/StakeholderCardDetails";
import { searchZipCode } from "../../../../services/StakeholderApi";
import { normalizeState, normalizeCountry } from "../../../../utils/normalizer";
import { isValidCoordinate } from "../../../../utils/validators";
import SearchHospitalAutosuggest, { LocationSuggestion } from "../../../../common/SearchHospitalAutosuggest";
import { addMedicareLocation } from "../../../../services/SystemLocationAPI";
import { SUBJECT_ADDRESS, SUBJECT_LOG_HEADERS } from "../actions/constant";
import DataTableAddress from "../../../../common/DataTableAddress";

import Snackbar from "../../../../common/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/Store";
import { setCaseSubjectId } from "../../../../redux/slice/CaseSubjectSlice";
import TagComponent from "../../../../common/TagComponent";
import {
  validateCaseSubjectAddress,
  validateCaseSubjectInfo,
} from "../actions/CaseSubjectValidation";
import moment from "moment";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import { CONTACT_LOG_HEADERS } from "../../../Master/Stakeholders/actions/Constant";
import DataTable from "../../../../common/DataTable";
import EmployerDetailsCard from "./EmployeeDetailsCard";
import DateRangePicker from "../../../../common/CustomDateRangePicker";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import TimePicker from "../../../../common/TimePicker";
import AccordionComponent from "../../../../common/Accordion";
import Loader from "../../../../common/Loader";
import NewPartiesDrawer from "../../Case_Information/components/NewPartiesDrawer";
import AddNewPartyClient from "../../Case_Information/components/AddNewPartyClient";
import { fetchCaseStages } from "../../../../redux/slice/caseStagesSlice";
import { useIsStageReadOnly } from "../../../../utils/caseStageChecker";
import {
  fetchQMEDoctorContacts,
  fetcQMEDoctorList,
} from "../../../../services/ScheduleAppointmentApi";
import {
  addCaseheaderDetails,
  fetchCaseheaderinfo,
} from "../../../../services/CaseInformationApi";
import {
  setCaseId,
  setCaseInfoId,
  setIsDashboard,
  setNewCaseInFoID,
  setPatientDetails,
} from "../../../../redux/slice/CaseHeaderSlice";
import { updateCaseStageAction } from "../../../../services/ActivityUpdateApi";
import { CASE_ACTIONS } from "../../../../common/EventConstant";
import { useNavigate, useLocation } from "react-router-dom";

interface AddCaseSubjectProps {
  userData: any;
  action: string;
  loggedInUserid: any;
  caseStageId: any;
  onCancel: (action: string) => void;
  headerActiveTab: string;
  userRole: string;
}
interface Option1 {
  salutationId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  subjectDob?: string;
  claimNumber?: any;
  subjectSSN?: any;
  genderId?: string;
  qmeDoctorContactId?: number;
  caseInfoId?: number;
  caseSubjectId?: number;
}

interface Option {
  areaName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  country?: string;
}

type ActionType =
  | "OnHold"
  | "Resumed"
  | "Cancelled"
  | "Closed"
  | "Archived"
  | "Unarchived";

const extractSpecialization = (name: string): string | null => {
  const parts = name?.split("(");
  if (parts?.length > 1) {
    return parts[1].replace(")", "")?.trim();
  }
  return null;
};

const Case_Subject: React.FC<AddCaseSubjectProps> = ({
  userData,
  action,
  loggedInUserid,
  caseStageId,
  onCancel,
  headerActiveTab,
  userRole,
}) => {
  //const isEditable = action != "View";
  const isEditableNew = action === "Edit";

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );

  const hasCaseActionAccess = Array.from(allowedFeatures).some((feature) =>
    Object.values(CASE_ACTIONS).includes(feature),
  );

  const dispatch = useDispatch();
  const dispatchNew = useDispatch<AppDispatch>();
  const { caseSubjectId } = useSelector(
    (state: RootState) => state.caseSubject,
  );

  const caseInfoID = useSelector(
    (state: RootState) => state.caseHeader.caseInfoId,
  );
  const { currentStage } = useSelector((state: RootState) => state.caseStages);
  const caseStage = useSelector(
    (state: RootState) => state.caseHeader.caseStage,
  );
  const caseStatus = useSelector((state: RootState) => state.caseHeader.status);
  const { view_Case } = useSelector((state: RootState) => state.featureAccess);
  const [isEditable, setIsEditable] = useState<boolean>(
    currentStage === CASE_STAGE_STATUS.NEW,
  );
  const isStageNonEditable = useIsStageReadOnly();
  const [saluationOption, setSaluationOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [genderOption, setGenderOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [employerOption, setEmployerOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [employerAddressOption, setEmployerAddressOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [employerContactOption, setEmployerContactOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [addressOption, setAddressOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [priorityTypeOption, setPriorityTypeOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [caseReviewOption, setCaseReviewOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [caseStageOption, setCaseStageOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [subjectIDToUpdate, setSubjectIDToUpdate] = useState<number | null>(
    null,
  );
  const [saluation, setSaluation] = useState<string | number | null>(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [aka, setAKA] = useState("");
  const [dob, setDob] = useState<Date | null>(null);
  const [gender, setGender] = useState<string | number | null>(null);
  const [ssnNumber, setSSNNumber] = useState("");
  const [unmaskedSSN, setUnmaskedSSN] = useState(""); // Unmasked SSN (for payload)
  const [isSSNFocused, setIsSSNFocused] = useState(false);
  const [employee, setEmployee] = useState<string | number | null>(null);
  const [stakeholderActive, setStakeholderActive] = useState<
    string | number | null
  >(null);
  const [address, setAddress] = useState<string | number | null>(null);
  const [contact, setContact] = useState<string | number | null>(null);

  const [addressType, setAddressType] = useState<string | number | null>(null);

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [suggestionFilled, setSuggestionFilled] = useState({ city: false, state: false, country: false, zip: false });
  const [pendingGoogleLocation, setPendingGoogleLocation] = useState<any>(null);
  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [addressID, setAddressID] = useState<number | null>(null);
  const [addressDetails, setAddressDetails] = useState({
    city: "",
    state: "",
    country: "",
    zip: "",
  });
  const [addressline1, setAddressLine1] = useState("");
  const [addressline2, setAddressLine2] = useState("");
  const [addressline3, setAddressLine3] = useState("");

  const [gridAddressData, setAddressGridData] = useState<any[]>([]);
  const [phoneNumber, setPhoneNumber] = useState<string[]>([]);
  const [emailAddress, setEmailAddress] = useState<string[]>([]);
  const [faxNumber, setFaxNumber] = useState<string[]>([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [showPreviousAddress, setShowPreviousAddress] = useState(true);
  const [addressLogDetails, setAddressLogDetails] = useState<any[]>([]);
  const [showLogDrawer, setShowLogDrawer] = useState(false);
  const [isPrimaryAddress, setPrimaryAddress] = useState(false);
  const [employerDetails, setEmployerDetails] = useState({
    employerName: "",
    employerAddress: "",
    employerCity: "",
    employerState: "",
    employerZipcode: "",
    employerCountry: "",
    employerContact: "",
    empcontactemailaddress: "",
    empcontactphonenumber: "",
    empcontactfaxnumber: "",
  });

  const today = new Date().toISOString().split("T")[0];
  const [originalData, setOriginalData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    saluation: "",
    aka: "",
    dob: "",
    gender: "",
    ssnNumber: "",
    employee: "",
    address: "",
    contact: "",
  });
  const [fullName, setFullName] = useState("");
  const [employerNameLabel, setEmployerName] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [employementKey, setEmployementKey] = useState<string | null>("0");
  const [subjectaddressKey, setSubjectAddressKey] = useState<string | null>(
    null,
  );
  const [addressDetailsKey, setAddressDetailsKey] = useState<string | null>(
    null,
  );
  const [savedEmployerName, setSavedEmployerName] = useState("");
  const [salutaionName, setSalutionName] = useState("");
  const [savedSaluationName, setSavedSaluationName] = useState("");

  const [loading, setLoading] = useState<boolean>(false);
  const [QMEDoctor, setQMEDoctor] = useState<string | null | number>(null);
  const [QMEDoctorOptions, setQMEDoctorOptions] = useState<
    {
      value: string;
      label: string;
      specialization: string;
      contactFullName: string;
    }[]
  >([]);
  const [specialization, setSpecialization] = useState<string | null | number>(
    "",
  );
  const [isPatinetDetailsDisable, setIsPatinetDetailsDisable] =
    useState<boolean>(false);
  const [onSaveCaseInfo, setOnSaveCaseInfo] = useState<string | null | number>(
    null,
  );
  const [onPatientSelectCaseInfoID, setOnPatientSelectCaseInfoID] =
    useState<any>(null);
  const [onPatientSelectSaveCaseInfoID, setOnPatientSelectSaveCaseInfoID] =
    useState<any>(null);

  const newStage = caseStageId.find(
    (item: { label: string }) => item.label === "New",
  );

  const params = {
    salutation: {
      groupName: PICKLIST_GROUP_NAME.Salutation_Type,
      triggerById: loggedInUserid,
    },
    gender: {
      groupName: PICKLIST_GROUP_NAME.Gender,
      triggerById: loggedInUserid,
    },
    addressType: {
      groupName: PICKLIST_GROUP_NAME.Address_Type,
      triggerById: loggedInUserid,
    },
    priorityType: {
      groupName: PICKLIST_GROUP_NAME.Case_Priority,
      triggerById: loggedInUserid,
    },
    caseReview: {
      groupName: PICKLIST_GROUP_NAME.Case_Review_Type,
      triggerById: loggedInUserid,
    },
    caseStages: {
      groupName: PICKLIST_GROUP_NAME.Case_Stages,
      triggerById: loggedInUserid,
    },
  };

  const getCaseInfoID = userData?.caseInfoId ? userData.caseInfoId : caseInfoID;
  const [ArChived, setArChived] = useState<number | null>(null);

  const [SubjectId, setSubjectId] = useState<number | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [actionReason, setActionReason] = useState("");
  const [selectedAction, setSelectedAction] = useState<ActionType | null>(null);
  const [showReasonError, setShowReasonError] = useState(false);
  const navigate = useNavigate();

  // const fetchData = async () => {
  //   try {
  //     const [
  //       salutationData,
  //       genderData,
  //       addressData,
  //       caseStageData,
  //       QMEDoctorData,
  //       employerData,
  //     ] = await Promise.all([
  //       fetchPickListByGroupName(params.salutation),
  //       fetchPickListByGroupName(params.gender),
  //       fetchPickListByGroupName(params.addressType),
  //       fetchPickListByGroupName(params.caseStages),
  //       fetchQMEDoctorContacts(loggedInUserid),
  //       fetchEmployerGroup(
  //         STAKEHOLDER_LIST_CODE.EMPLOYER,
  //         stakeholderActive ? " " : 1
  //       ),
  //     ]);

  //     setSaluationOption(salutationData || []);
  //     setGenderOption(genderData || []);
  //     setAddressOption(addressData || []);
  //     setCaseStageOption(caseStageData || []);
  //     setQMEDoctorOptions(QMEDoctorData || []);
  //     setEmployerOption(employerData || []);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const fetchData = () => {
    try {
      fetchPickListByGroupName(params.salutation)
        .then((data) => {
          setSaluationOption(data || []);
        })
        .catch((error) => console.error("Salutation API error:", error));

      fetchPickListByGroupName(params.gender)
        .then((data) => {
          setGenderOption(data || []);
        })
        .catch((error) => console.error("Gender API error:", error));

      fetchPickListByGroupName(params.addressType)
        .then((data) => {
          setAddressOption(data || []);
        })
        .catch((error) => console.error("Address API error:", error));

      fetchPickListByGroupName(params.caseStages)
        .then((data) => {
          setCaseStageOption(data || []);
        })
        .catch((error) => console.error("Case Stage API error:", error));

      fetchQMEDoctorContacts(loggedInUserid)
        .then((data) => {
          setQMEDoctorOptions(data || []);
        })
        .catch((error) => console.error("QME Doctor API error:", error));

      fetchEmployerGroup(
        STAKEHOLDER_LIST_CODE.EMPLOYER,
        stakeholderActive ? " " : 1,
      )
        .then((data) => {
          setEmployerOption(data || []);
        })
        .catch((error) => console.error("Employer API error:", error));

      fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
        triggerById: loggedInUserid,
      })
        .then((data) => {
          setInstructionOption(data || []);
        })
        .catch((error) => console.error("Instruction options API error:", error));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchInfoData = async (newCaseInfoID?: any) => {
    try {
      setLoading(true);
      const caseIdInfo = newCaseInfoID || getCaseInfoID;
      // const [headerData, QMEDoctorDataNew] = await Promise.all([
      //   fetchSubjectInfo(caseIdInfo),
      //   fetchQMEDoctorContacts(loggedInUserid),
      // ]);
      const headerData = await fetchSubjectInfo(caseIdInfo);
      if (!headerData) return;
      setIsPatinetDetailsDisable(headerData?.salutationTypeId ? true : false);
      setSaluation(headerData.salutationTypeId || "");
      setFirstName(headerData.firstName || "");
      setMiddleName(headerData.middleName || "");
      setLastName(headerData.lastName || "");
      setAKA(headerData.subjectAKA || "");
      setGender(headerData.subjectGenderId || "");
      setSSNNumber(headerData.subjectSSN || "");
      setEmployee(headerData.employerStakeholderId || "");
      setStakeholderActive(headerData.employerStakeholderId || "");
      setAddress(headerData.employerAddressId || "");
      setContact(headerData.employerContactId || "");
      setSubjectIDToUpdate(headerData.caseSubjectId || "");
      setQMEDoctor(headerData.qmeDoctorContactId || "");

      let formattedDOB = headerData.subjectDOB
        ? headerData.subjectDOB.split("T")[0]
        : "";

      // Ignore "0001-01-01" as it's a placeholder for null
      if (formattedDOB === "0001-01-01") {
        formattedDOB = "";
      }

      setDob(formattedDOB);

      let formattedSSN = "";

      if (headerData.subjectSSN) {
        const receivedSSN = headerData.subjectSSN.replace(/\D/g, ""); // Remove non-numeric characters
        formattedSSN =
          receivedSSN.length === 9
            ? `${receivedSSN.slice(0, 3)}-${receivedSSN.slice(
              3,
              5,
            )}-${receivedSSN.slice(5)}`
            : receivedSSN;

        setUnmaskedSSN(formattedSSN); // Store the original SSN (for editing)
        setSSNNumber(`XX-XXX-${formattedSSN.slice(-4)}`); // Masked format for UI
      } else {
        setUnmaskedSSN("");
        setSSNNumber("");
      }
      // const selectedDoctor = QMEDoctorDataNew?.find(
      //   (doctor: any) =>
      //     Number(doctor.value) === Number(headerData.qmeDoctorContactId)
      // );

      // if (selectedDoctor) {
      //   const SpecilizationInfo = extractSpecialization(
      //     selectedDoctor?.contactFullName
      //   );
      //   setSpecialization(SpecilizationInfo || "");
      // }
      setEmployerDetails({
        employerName: headerData.employerName || "",
        employerAddress: headerData.employerAddress || "",
        employerCity: headerData.employerCity || "",
        employerState: headerData.employerState || "",
        employerZipcode: headerData.employerZipcode || "",
        employerCountry: headerData.employerCountry || "",
        employerContact: headerData.employerContact || "",
        empcontactemailaddress: headerData.empcontactemailaddress || "",
        empcontactphonenumber: headerData.empcontactphonenumber || "",
        empcontactfaxnumber: headerData.empcontactfaxnumber || "",
      });

      const formattedCreatedDate = headerData.createddate
        ? moment(headerData.createddate).format("MM/DD/YYYY | hh:mm A")
        : "N/A";

      const formattedModifiedDate = headerData.modifieddate
        ? moment(headerData.modifieddate).format("MM/DD/YYYY | hh:mm A")
        : "N/A";

      setAddressLogDetails([
        {
          createdbyName: headerData.createdbyName || "N/A",
          createddate: formattedCreatedDate,
          modifiedbyName: headerData.modifiedbyName || "N/A",
          modifieddate: formattedModifiedDate,
        },
      ]);
      setOriginalData({
        saluation: headerData.salutationTypeId || "",
        firstName: headerData.firstName || "",
        middleName: headerData.middleName || "",
        lastName: headerData.lastName || "",
        aka: headerData.subjectAKA || "",
        dob: formattedDOB,
        gender: headerData.subjectGenderId || "",
        ssnNumber: formattedSSN,
        employee: headerData.employerStakeholderId || "",
        address: headerData.employerAddressId || "",
        contact: headerData.employerContactId || "",
      });

      const firstName = headerData.firstName || "";
      const middleName = headerData.middleName || "";
      const lastName = headerData.lastName || "";

      // Combine all into a full name string
      const combinedName = [firstName, middleName, lastName]
        .filter((part) => part) // remove any empty strings
        .join(" ");

      setFullName(combinedName);

      const formattedName =
        `${headerData.salutationName || ""} ${headerData.lastName || ""}, ${headerData.firstName || ""} (${headerData.customerAccountNo || ""})`
          .replace(/\s+/g, " ")
          .trim();
      dispatch(setPatientDetails(formattedName));
    } catch (error) {
      console.error("Error fetching info data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (getCaseInfoID) {
      fetchInfoData(onPatientSelectCaseInfoID);
    }
  }, []);

  useEffect(() => {
    if (!getCaseInfoID) return;
    const fetchHeader = async () => {
      try {
        const headerInfo = await fetchCaseheaderinfo(getCaseInfoID);
        if (headerInfo) {
          setArChived(headerInfo?.isArchive);
           dispatch(setCaseTypeName(headerInfo?.caseReviewTypeName));
          
        }
      } catch (error) {
        console.error("Error fetching case header info:", error);
      }
    };
    if (getCaseInfoID) {
      fetchInfoData(onPatientSelectSaveCaseInfoID);
      fetchHeader();
    }
  }, [headerActiveTab]);

  useEffect(() => {
    if (!employee) return;

    const fetchEmployerData = async () => {
      try {
        const [employerAddressData, employerContactData] = await Promise.all([
          fetchEmployerAddress(employee),
          fetchEmployerContact(employee),
        ]);

        setEmployerAddressOption(employerAddressData || []);
        setEmployerContactOption(employerContactData || []);

        if (employerAddressData?.length === 1) {
          setAddress(employerAddressData[0].value ?? employerAddressData[0]);
        }
        if (employerContactData?.length === 1) {
          setContact(employerContactData[0].value ?? employerContactData[0]);
        }
      } catch (error) {
        console.error("Error fetching employer data:", error);
      }
    };

    fetchEmployerData();
  }, [employee]);

  const hasChanges = () => {
    const formattedDob =
      dob instanceof Date ? dob.toISOString().split("T")[0] : dob; // Ensure dob is a string

    return (
      firstName !== originalData.firstName ||
      middleName !== originalData.middleName ||
      lastName !== originalData.lastName ||
      saluation !== originalData.saluation ||
      aka !== originalData.aka ||
      formattedDob !== originalData.dob || // Ensure proper comparison
      gender !== originalData.gender ||
      unmaskedSSN !== originalData.ssnNumber || // Compare unmasked SSN
      employee !== originalData.employee ||
      address !== originalData.address ||
      contact !== originalData.contact
    );
  };

  const fetchAddressData = async () => {
    try {
      if (!subjectIDToUpdate || subjectIDToUpdate === 0) {
        return; // Prevent API call when subjectIDToUpdate is 0 or falsy
      }

      const response = await GetSubjectAddressList(Number(subjectIDToUpdate));
      setAddressGridData(response || []);
    } catch (error) {
      console.error("Error fetching address data:", error);
    }
  };

  const [defaultPrimaryAddress, setdefaultPrimaryAddress] = useState(false);

  const handleAddContact = () => {
    setActiveKey(null);
    setEmployementKey(null);
    setAddressDetailsKey(null);
    setSubjectAddressKey("0");
    setShowForm(true);
    // Reset selected contact when adding new contact
    setAddressID(null);
    setAddressType("");
    setAddressLine1("");
    setAddressLine2("");
    setAddressLine3("");
    if (gridAddressData.length === 0) {
      setPrimaryAddress(true);
      setdefaultPrimaryAddress(true); // disables checkbox
    } else {
      setPrimaryAddress(false);
      setdefaultPrimaryAddress(false);
    }
    setPhoneNumber([]);
    setEmailAddress([]);
    setFaxNumber([]);

    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
    });
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zip: false });
    setPendingGoogleLocation(null);

    setSearchQuery("");
  };

  const cancelAddressForm = () => {
    setShowForm(false);

    // Reset all fields to initial state
    setAddressDetailsKey("0");
    setAddressID(null);
    setAddressType("");
    setAddressLine1("");
    setAddressLine2("");
    setAddressLine3("");
    setPhoneNumber([]);
    setEmailAddress([]);
    setFaxNumber([]);
    setPrimaryAddress(false);
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zip: false });
    setPendingGoogleLocation(null);
    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
    });

    setSearchQuery("");
  };

  useEffect(() => {
    fetchAddressData();
  }, [subjectIDToUpdate]);

  useEffect(() => {
    if (employee && employerOption.length > 0) {
      const selectedEmployer = employerOption.find(
        (option) => option.value === employee,
      );
      const employerLabel = selectedEmployer ? selectedEmployer.label : "";
      setEmployerName(employerLabel);

      // Only set this when fetching info from DB
      if (subjectIDToUpdate) {
        setSavedEmployerName(employerLabel); // <-- new state
      }
    }
    if (saluation && saluationOption.length > 0) {
      const selectedSaluation = saluationOption.find(
        (option) => option.value === saluation,
      );
      const saluationLabel = selectedSaluation ? selectedSaluation.label : "";
      setSalutionName(saluationLabel);

      // Only set this when fetching info from DB
      if (subjectIDToUpdate) {
        setSavedSaluationName(saluationLabel); // <-- new state
      }
    }
  }, [employee, employerOption]);

  useEffect(() => {
    fetchData();

    // fetchAddressData();
  }, [employee]);

  const handleSuggestionSelect = (suggestion: LocationSuggestion) => {
    const newStateCode = suggestion.physicalStateCode || normalizeState(suggestion.physicalState || "");
    const newCountryCode = normalizeCountry(suggestion.country || "");

    if (suggestion.source === "google") {
      setPendingGoogleLocation({
        source: "google",
        providerName: suggestion.providerName,
        providerAddress: suggestion.providerAddress,
        physicalCity: suggestion.physicalCity,
        physicalState: newStateCode,
        physicalZip: suggestion.physicalZip,
        countryName: newCountryCode,
        county: suggestion.county,
        areaName: suggestion.areaName || "",
        latitude: isValidCoordinate(suggestion.latitude) ? String(suggestion.latitude) : "",
        longitude: isValidCoordinate(suggestion.longitude) ? String(suggestion.longitude) : "",
      });
    } else {
      setPendingGoogleLocation(null);
    }
    setSuggestionSelected(true);
    setSuggestionFilled({
      city: !!suggestion.physicalCity,
      state: !!newStateCode,
      country: !!newCountryCode,
      zip: !!suggestion.physicalZip,
    });
    setAddressDetails({
      city: suggestion.physicalCity || "",
      state: newStateCode,
      country: newCountryCode || "USA",
      zip: suggestion.physicalZip || "",
    });
    setAddressLine1(suggestion.providerAddress || suggestion.providerName || "");
  };

  // Function to format the SSN as per the required pattern
  const [searchQuery1, setSearchQuery1] = useState("");
  const [filteredResults1, setFilteredResults1] = useState<any[]>([]);
  const [selectedOption1, setSelectedOption1] = useState<any>(null);
  const [isAddNewPatient, setIsAddNewPatient] = useState(false);
  useEffect(() => {
    if (isAddNewPatient) {
      setSelectedOption1(null);
      setSearchQuery1("");
      setFilteredResults1([]);
      setSaluation("");
      setFirstName("");
      setMiddleName("");
      setLastName("");
      setDob(null);
      setSSNNumber("");
      setGender("");
      setOnPatientSelectCaseInfoID(null);
    }
  }, [isAddNewPatient]);

  const handleSearchChange1 = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = e.target.value;
    setSearchQuery1(value);
    setFilteredResults1([]);
    if (value.length >= 3) {
      try {
        const results = await searchCaseSubjectByText(value.trim());
        if (Array.isArray(results)) {
          setFilteredResults1(results);
        }
      } catch (error) {
        console.error("Search failed", error);
        setFilteredResults1([]);
      }
    } else {
      setFilteredResults1([]);
    }
  };

  const handleSelect1 = (option: Option1) => {
    setSelectedOption1(option);
    setSearchQuery1(
      `${option.firstName ?? ""} ${option.middleName ?? ""} ${option.lastName ?? ""
      }`,
    );
    setIsPatinetDetailsDisable(true);
    setFilteredResults1([]);

    setSaluation(option.salutationId ?? "");
    setFirstName(option.firstName ?? "");
    setMiddleName(option.middleName ?? "");
    setLastName(option.lastName ?? "");
    setDob(option.subjectDob ? moment(option.subjectDob).toDate() : null);
    setSSNNumber(option.subjectSSN ?? "");
    setGender(option.genderId ?? "");
    setQMEDoctor(option.qmeDoctorContactId ?? null);
    setShowForm(true);
    setIsAddNewPatient(false);
    // setOnPatientSelectCaseInfoID(option?.caseInfoId);
    // fetchInfoData(option?.caseInfoId);
    setSubjectId(Number(option?.caseSubjectId));
    setOpenConfirm(userData?.caseInfoId ? false : true);
  };

  const handleSSNChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (value.length > 3) value = value.slice(0, 3) + "-" + value.slice(3);
    if (value.length > 6) value = value.slice(0, 6) + "-" + value.slice(6);

    setUnmaskedSSN(value.slice(0, 11)); // Store unmasked version
    setSSNNumber(value.slice(0, 11)); // Store formatted version for UI
  };

  const maskSSN = () => {
    if (unmaskedSSN.length === 11) {
      setSSNNumber(`XX-XXX-${unmaskedSSN.slice(-4)}`); // Mask only for display
    }
  };
  // Function to show original SSN when input is focused
  const unmaskSSN = () => {
    setIsSSNFocused(true);
    setSSNNumber(unmaskedSSN); // Show full SSN when focused
  };

  const validateInfoForm = () => {
    let formattedDob = "";

    if (dob instanceof Date) {
      formattedDob = dob.toISOString().split("T")[0]; // Convert Date to "yyyy-mm-dd"
    } else if (typeof dob === "string") {
      formattedDob = dob; // If dob is already a string, use it directly
    }
    const validationErrors = validateCaseSubjectInfo(
      saluation,
      firstName,
      lastName,
      formattedDob,
      gender,
      ssnNumber,
      employee,
      address,
      contact,
      QMEDoctor,
    );

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true; // No need to reset the snackbar message here
  };

  const [isSaving, setIsSaving] = useState(false);

  const handleSaveInfo = async () => {
    if (isSaving) return;

    if (validateInfoForm()) {
      try {
        setIsSaving(true);
        setLoading(true);

        let formattedDob: string | null = null;

        if (dob instanceof Date) {
          formattedDob = dob.toISOString().split("T")[0];
        } else if (typeof dob === "string") {
          formattedDob = dob;
        }

        const payload = {
          caseSubjectId: subjectIDToUpdate ? subjectIDToUpdate : null,
          caseInfoId: getCaseInfoID,
          salutationTypeId: saluation,
          firstName,
          middleName,
          lastName,
          subjectAKA: aka,
          subjectDOB: formattedDob,
          subjectGenderId: gender,
          subjectSSN: unmaskedSSN,
          employerStakeholderId: employee,
          employerAddressId: address ? address : null,
          employerContactId: contact ? contact : null,
          qmeDoctorContactId: QMEDoctor || null,
          isActive: 1,
        };

        let saveInfo;
        let caseInfoIdLocal = getCaseInfoID;

        const newStageID = caseStageOption.find(
          (item: { label: string }) => item.label === CASE_STAGE_STATUS.NEW,
        );

        if (!subjectIDToUpdate && !onSaveCaseInfo) {
          const payloadAdd = {
            priorityid: null,
            casereviewtypeid: null,
            claimnumber: null,
            casestageid: newStageID?.value,
            createdby: loggedInUserid,
          };

          const response = await addCaseheaderDetails(payloadAdd);
          caseInfoIdLocal = response?.result?.id;

          if (caseInfoIdLocal) {
            setOnSaveCaseInfo(caseInfoIdLocal);
            saveInfo = await addCaseSubject({
              ...payload,
              caseInfoId: caseInfoIdLocal,
            });
            dispatch(setCaseInfoId(caseInfoIdLocal));
          }
        } else {
          saveInfo = await updateCaseSubject(payload);
        }

        if (saveInfo && saveInfo.isSuccess) {
          const newSubjectId = saveInfo.result;

          if (!subjectIDToUpdate) dispatch(setCaseSubjectId(saveInfo.result));

          setSnackbarMessage(
            subjectIDToUpdate
              ? "Patient Details Updated successfully"
              : "Patient details added successfully.",
          );
          setError("success");
          setSnackbarOpen(true);

          fetchInfoData(subjectIDToUpdate ? getCaseInfoID : caseInfoIdLocal);

          setSavedEmployerName(employerNameLabel);
          setSavedSaluationName(salutaionName);
          setemploymentsubdetailKey("0");

          if (subjectIDToUpdate) {
            dispatchNew(fetchCaseStages(getCaseInfoID));
            const stage = await fetchCaseheaderinfo(getCaseInfoID);

            setIsEditable(stage?.caseStageName === CASE_STAGE_STATUS.NEW);
          }
        } else {
          setSnackbarMessage("Failed to save patient info");
          setError("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsSaving(false);
        setLoading(false);
      }
    }
  };

  const handleCancel = async () => {
    setActiveKey(null);
    setEmployementKey(null);
    await fetchInfoData(); // Re-fetch and update state with original values
  };

  const handleRowAction = (actionType: string, contact: any) => {
    setShowForm(true);
    setdefaultPrimaryAddress(false);
    setAddressDetailsKey(null);
    setSubjectAddressKey("0");
    setAddressID(contact.caseSubjectAddressId);
    setAddressType(contact.addressTypeId); // Set Address Type
    setAddressLine1(contact.addressLine1 || "");
    setAddressLine2(contact.addressLine2 || "");
    setAddressLine3(contact.addressLine3 || "");
    setPrimaryAddress(contact.isPrimaryAddress);
    setPhoneNumber(
      contact.phoneNumber
        ? contact.phoneNumber.split(",").map((num: string) => num.trim())
        : [],
    );
    setEmailAddress(
      contact.emailAddress
        ? contact.emailAddress.split(",").map((num: string) => num.trim())
        : [],
    );

    setFaxNumber(
      contact.faxNumber
        ? contact.faxNumber.split(",").map((num: string) => num.trim())
        : [],
    );

    setAddressDetails({
      city: contact.city || "",
      state: contact.state || "",
      country: contact.country || "",
      zip: contact.zipCode || "",
    });

    // setSearchQuery(
    //   `${contact.city}, ${contact.state}, ${contact.country} ${contact.zipCode}`,
    // );
  };

  const [showTooltip, setShowTooltip] = useState(false);

  const handlePDFClick = () => {
    if (!subjectIDToUpdate) return; // Ensure an address is selected

    setAddressLogDetails(addressLogDetails); //

    setShowLogDrawer(true);
    setShowTooltip(false);
  };

  const handleCloseLogDrawer = () => {
    setShowLogDrawer(false);
  };

  const validateSubjectForm = () => {
    const validationErrors = validateCaseSubjectAddress(
      addressType,
      addressDetails,
      addressline1,
      phoneNumber,
      emailAddress,
      faxNumber,
    );

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSaveAddress = async () => {
    if (isSaving) return;
    try {
      setIsSaving(true);
      if (validateSubjectForm()) {
        const isTryingToAddPrimary = isPrimaryAddress === true;
        const existingPrimary = gridAddressData.find(
          (item) => item.isPrimaryAddress === 1,
        );

        const isEditingSamePrimary =
          addressID &&
          existingPrimary &&
          existingPrimary.caseSubjectAddressId === addressID;

        if (
          isTryingToAddPrimary &&
          existingPrimary &&
          !isEditingSamePrimary // prevent blocking when updating same primary
        ) {
          setSnackbarMessage("Only one primary address is allowed!");
          setError("error");
          setSnackbarOpen(true);
          return; // Block save
        }

        const payload = {
          subjectAddressId: addressID ? addressID : null,
          caseSubjectId: subjectIDToUpdate,
          addressTypeId: addressType,
          addressLine1: addressline1,
          addressLine2: addressline2,
          addressLine3: addressline3,
          city: addressDetails.city,
          state: addressDetails.state,
          zipCode: addressDetails.zip,
          country: addressDetails.country,
          phoneNumber: phoneNumber.length > 0 ? phoneNumber.join(",") : "",
          faxNumber: faxNumber.length > 0 ? faxNumber.join(",") : "",
          emailAddress: emailAddress.length > 0 ? emailAddress.join(",") : "",
          isPrimary: isPrimaryAddress == true ? 1 : 0,
          comments: "string",
          isActive: 0,
          createdBy: loggedInUserid,
        };

        let saveAddress;
        if (!addressID) {
          saveAddress = await addCaseSubjectAddress(payload);
        } else {
          saveAddress = await updateCaseSubjectAddress(payload);
        }
        if (saveAddress && saveAddress.result) {
          if (pendingGoogleLocation?.source === "google") {
            const locationResult = await addMedicareLocation({
              medicareId: 0,
              providerName: pendingGoogleLocation.providerName || searchQuery,
              providerAddress: addressline1 || pendingGoogleLocation.providerAddress,
              physicalCity: addressDetails?.city || pendingGoogleLocation.physicalCity || "",
              physicalState: addressDetails?.state || pendingGoogleLocation.physicalState || "",
              physicalZip: addressDetails?.zip || pendingGoogleLocation.physicalZip || "",
              countryName: addressDetails?.country || pendingGoogleLocation.countryName || "USA",
              providerType: "Medicare",
              latitude: pendingGoogleLocation.latitude,
              longitude: pendingGoogleLocation.longitude,
              county: pendingGoogleLocation.county,
              telephoneNumber: "",
              faxNumber: "",
              emailId: "",
              splInstructions: instructionOption.map((opt: any) => ({
                SplInstructionID: opt.value,
                SplInstructionData: "",
              })),
              contactName: "",
              regionId: null,
              createdBy: loggedInUserid,
            }).catch((err: any) => { console.error("Failed to save Google location:", err); return null; });
            setPendingGoogleLocation(null);
          }
          // Set the ID after saving
          setSnackbarMessage(
            addressID
              ? "Paitent Address Details Updated successfully"
              : "Patient address details added successfully",
          );
          setError("success");
          setSnackbarOpen(true);
          setShowForm(false);
          setAddressDetailsKey("0");
          setSearchQuery("");
          fetchInfoData();
          fetchAddressData();
          dispatchNew(fetchCaseStages(getCaseInfoID));
        } else {
          setSnackbarMessage("Failed to subject info");
          setError("error");
          setSnackbarOpen(true);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsSaving(false);
    }
  };

  const handleBack = () => {
    onCancel("Cancel");
  };

  const personalDetailsAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : item.title === "Personal Details" ? (
            <>
              {item.title}{" "}
              <span className="fw-normal">
                {fullName ? ` - ${savedSaluationName} ${fullName}` : ""}
              </span>
            </>
          ) : (
            item.title
          ),
      }))}
      activeKey={activeKey}
      onSelect={(key) => setActiveKey(key as string)}
    />
  );

  const employementDetailsAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          employementKey === index.toString() ? (
            item.title
          ) : item.title === "Employer Details" ? (
            <>
              {item.title}{" "}
              <span className="fw-normal">
                {savedEmployerName ? ` - ${savedEmployerName} ` : ""}
              </span>
            </>
          ) : (
            item.title
          ),
      }))}
      activeKey={employementKey}
      onSelect={(key) => setEmployementKey(key as string)}
    />
  );

  const subjectadressAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={subjectaddressKey}
      onSelect={(key) => setSubjectAddressKey(key as string)}
    />
  );

  const addressDetailsAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addressDetailsKey}
      onSelect={(key) => setAddressDetailsKey(key as string)}
    />
  );

  const [employmentsubdetailKey, setemploymentsubdetailKey] = useState<
    string | null
  >(null);

  const employmentdetailsubAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={employmentsubdetailKey}
      onSelect={(key) => setemploymentsubdetailKey(key as string)}
    />
  );

  // useEffect(() => {
  //   if (subjectIDToUpdate) {
  //     setActiveKey(null);
  //     setEmployementKey(null);
  //   } else {
  //     setActiveKey("0");
  //     setEmployementKey("0");
  //   }
  // }, [subjectIDToUpdate]);

  useEffect(() => {
    if (activeKey === "0" || employementKey === "0") {
      setSubjectAddressKey(null);
      setAddressDetailsKey(null);
    }
  }, [activeKey, employementKey]);

  useEffect(() => {
    if (subjectaddressKey === "0" || addressDetailsKey === "0") {
      setActiveKey(null);
      setEmployementKey(null);
      setemploymentsubdetailKey(null);
    }
  }, [subjectaddressKey, addressDetailsKey]);

  const [partyType, setPartyType] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [showPartyModal, setShowPartyModal] = useState(false);

  const [partyHeaderID, setPartyHeaderID] = useState(null);
  const [hasAddressData, setHasAddressData] = useState(false);
  const [hasContactData, setHasContactData] = useState(false);

  const updatePartyTypeState = async (id: any, type: string) => {
    if (partyHeaderID && hasAddressData && hasContactData) {
      if (type === PARTY_TYPES.EMPLOYER) {
        setEmployee(Number(id));
        const employerAddressData = await fetchEmployerAddress(id);
        setEmployerAddressOption(employerAddressData || []);

        const employerContactData = await fetchEmployerContact(id);
        setEmployerContactOption(employerContactData || []);
      }
    }
  };

  const handlePartyDrawerClose = async () => {
    if (partyHeaderID && (!hasAddressData || !hasContactData)) {
      setShowPartyModal(true);
      await fetchData(); // Ensure modal still gets latest data
    } else {
      setShowDrawer(false);
      await fetchData(); // ⬅️ Wait for options like insuranceTypeOptions to be updated
      updatePartyTypeState(partyHeaderID, partyType); // ⬅️ Then set the ID
    }
  };

  const handlePartyConfirmCancel = () => {
    setShowPartyModal(false);
    setShowDrawer(false);
    fetchData();
  };

  const handlePartyCloseModal = () => {
    setShowPartyModal(false);
    fetchData();
  };

  const openDrawerWithType = (type: string) => {
    setPartyType(type);
    setShowDrawer(true);
  };

  type CaseStageStatus =
    (typeof CASE_STAGE_STATUS)[keyof typeof CASE_STAGE_STATUS];
  const actionVisibilityMap: Record<string, string[]> = {
    [CASE_STAGE_STATUS.REGISTERED]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.SCHEDULE]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.DOCUMENTPREPARATION]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.SCHEDULING]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.EVALUATION]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.DRAFTINGREPORT]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.REPORTRIVIEW]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.REPORTFINALIZE]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.BILLING]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.PAYMENTPENDING]: ["OnHold", "Closed", "Cancelled"],

    [CASE_STAGE_STATUS.PAYMENTCOMPLETE]: ["OnHold", "Closed", "Cancelled"],

    [CASE_STAGE_STATUS.DESPOSITION]: ["OnHold", "Closed", "Cancelled"],

    [CASE_STAGE_STATUS.REGISTEREDONHOLD]: [
      "Resumed",
      "Closed",
      // "Archived",
      // "Cancelled",
    ],
    [CASE_STAGE_STATUS.PAYMENTPENDINGONHOLD]: [
      "Resumed",
      "Closed",
      "Cancelled",
    ],
    [CASE_STAGE_STATUS.SCHEDULEONHOLD]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.DOCUMENTPREPARATIONONHOLD]: [
      "Resumed",
      "Closed",

      "Cancelled",
    ],
    [CASE_STAGE_STATUS.DESPOSITIONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.SCHEDULINGONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.EVALUATIONONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.DRAFTINGREPORTONHOLD]: [
      "Resumed",
      "Closed",
      "Cancelled",
    ],
    [CASE_STAGE_STATUS.REPORTRIVIEWONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.REPORTFINALIZEONHOLD]: [
      "Resumed",
      "Closed",
      "Cancelled",
    ],
    [CASE_STAGE_STATUS.BILLINGONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.PAYMENTCOMPLETEONHOLD]: [
      "Resumed",
      "Closed",

      "Cancelled",
    ],
    [CASE_STAGE_STATUS.COMPLIANCEREVIEWONHOLD]: [
      "Resumed",
      "Closed",

      "Cancelled",
    ],

    [CASE_STAGE_STATUS.RESUME]: ["OnHold", "Cancelled", "Closed"],
    [CASE_STAGE_STATUS.CANCELLED]: ["Archived"],
    [CASE_STAGE_STATUS.CLOSED]: ["Archived"],
    [CASE_STAGE_STATUS.ARCHIVED]: ["Cancelled", "Closed", "Unarchived"],
    [CASE_STAGE_STATUS.UNARCHIVED]: ["Archived"],
  };
  const visibleActions = actionVisibilityMap[currentStage] || [];

  if (ArChived === 1 && !visibleActions.includes("Unarchived")) {
    visibleActions.push("Unarchived");
  }

  const handleAction = async (actionType: ActionType, reason: string) => {
    try {
      const response = await updateCaseStageAction(
        getCaseInfoID,
        actionType,
        reason,
      );
      setSnackbarMessage(response.result || "Action completed successfully");
      setError("success");
      setSnackbarOpen(true);
      if (response?.isSuccess && response?.statusCode == 200) {
        dispatchNew(fetchCaseStages(getCaseInfoID));
        fetchInfoData();
      }
    } catch (err) {
      setSnackbarMessage("Something went wrong!");
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const confirmAndExecute = () => {
    if (!actionReason.trim()) {
      setShowReasonError(true);
      return;
    }

    handleAction(selectedAction as ActionType, actionReason);
    setShowConfirmModal(false);
    setActionReason("");
    setShowReasonError(false);
  };

  const allowedRoles = [WEB_ROLE.Case_Manager, WEB_ROLE.App_Admin];

  const canEditCase = allowedRoles.includes(userRole);

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleOpenPopup = () => {
    setOpenConfirm(true);
  };
  const handleConfirm = async () => {
    setOpenConfirm(false);
    setLoading(true);
    const result = await createCaseFromSubject(Number(SubjectId));

    if (result.caseInfoID != 0) {
      setOpenConfirm(false);
      navigate("/search-case", {
        state: {
          caseInfoID: result.caseInfoID,
          caseId: result.caseID,
          claimNumber: result.claimNumber,
        },
      });
    } else {
      setOpenConfirm(false);
    }
  };

  const location = useLocation();
  const isFromRecordReviewer = location.state?.from === "mytodos";
  const isFromAppointment = location.state?.from === "appointment";

  const handleReviewerBack = () => {
    dispatch(setIsDashboard(false));
    dispatch(setNewCaseInFoID(null));
    navigate("/mytodos", {
      state: location.state,
    });
  };

  const handleAppointmentTabBack = () => {
    dispatch(setIsDashboard(false));
    dispatch(setNewCaseInFoID(null));
    navigate("/appointment", {
      state: location.state,
    });
  };

  const handleNavigationBack = () => {
    if (isFromRecordReviewer) {
      handleReviewerBack();
    } else if (isFromAppointment) {
      handleAppointmentTabBack();
    } else {
      handleBack();
    }
  };

  return (
    <Container fluid className="pb-5 px-0 position-relative">
      <Loader isLoading={loading} />
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error} // Adjust the severity as needed
      />
      {/* <Row className="mt-3 align-items-center">
        <Col>
          <h5 className="sectionTitle">Personal Details</h5>
        </Col>
      </Row> */}

      <>
        {/* {userData?.caseInfoId ? (
          <Button
            variant="outline"
            className="btn d-flex align-items-center btn-text-border"
            onClick={handleBack}
            style={{ position: "absolute", right: "0", top: "-55px" }}
            disabled={!userData?.caseInfoId}
          >
            <span className="material-icons mr-1 ">arrow_back</span>Back
          </Button>
        ) : (
          ""
        )} */}
        {currentStage !== CASE_STAGE_STATUS.NEW && hasCaseActionAccess && (
          <Dropdown
            className="mb-3 position-absolute"
            style={{
              position: "absolute",
              right: "36px",
              width: "100px",
              top: "-50px",
            }}
          >
            <Dropdown.Toggle
              variant="primary"
              id="dropdown-actions"
              className="d-flex align-items-center action-btn "
            >
              <span className="material-symbols-outlined material-icons me-1">
                settings
              </span>
              Case Actions
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {visibleActions.includes("OnHold") && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("OnHold");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center border-bottom"
                >
                  <span className="material-icons me-2 theme-color">
                    pause_circle
                  </span>
                  On Hold
                </Dropdown.Item>
              )}

              {visibleActions.includes("Resumed") && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Resumed");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center border-bottom"
                >
                  <span className="material-icons me-2 theme-color ">
                    play_arrow
                  </span>
                  Resume
                </Dropdown.Item>
              )}

              {visibleActions.includes("Cancelled") && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Cancelled");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center border-bottom"
                >
                  <span className="material-icons me-2 theme-color ">
                    cancel
                  </span>
                  Cancel
                </Dropdown.Item>
              )}

              {visibleActions.includes("Closed") && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Closed");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center "
                >
                  <span className="material-icons me-2 theme-color">close</span>
                  Close
                </Dropdown.Item>
              )}

              {visibleActions.includes("Archived") && ArChived === 0 && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Archived");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center"
                >
                  <span className="material-icons me-2 text-info">archive</span>
                  Archive
                </Dropdown.Item>
              )}

              {visibleActions.includes("Unarchived") && ArChived === 1 && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Unarchived");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center"
                >
                  <span className="material-icons me-2 text-success">
                    unarchive
                  </span>
                  Un-archive
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
        <Modal show={openConfirm} onHide={handleCloseConfirm}>
          <Modal.Body className="fw-bold text-center modelheading ">
            <div>Copy Previous Case Details:</div>
          </Modal.Body>
          <div className="p-2 px-3 text-center">
            Do you want to copy{" "}
            <span className="theme-color">Header, Parties</span> and{" "}
            <span className="theme-color">Injury details</span> from the
            previous case?
          </div>
          <Modal.Footer className="border-0 d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={handleCloseConfirm}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              variant="primary"
              className="ms-3 d-flex align-items-center"
              onClick={handleConfirm}
            >
              <span className="material-icons mx-1">check</span> Yes
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showConfirmModal}
          onHide={() => {
            setShowConfirmModal(false);
            setActionReason("");
            setShowReasonError(false);
          }}
          centered
          className="recordList"
        >
          <Modal.Header closeButton className="d-flex">
            <Modal.Title className="fw-bold text-left modelheading offcanvas-title d-flex align-items-center">
              Are you sure you want to{" "}
              {selectedAction === "OnHold"
                ? "put the case on hold"
                : `perform the "${selectedAction}" action`}
              ?
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>
              {selectedAction?.toLowerCase() === "cancelled" ? (
                <>
                  Appointments scheduled during this time span will be cancelled{" "}
                  <br />
                  Please specify the reason for cancellation
                </>
              ) : selectedAction?.toLowerCase() === "closed" ? (
                <>
                  Appointments scheduled during this time span will be closed{" "}
                  <br />
                  Are you sure you want to perform the closed action?
                </>
              ) : (
                `Are you sure you want to perform the "${selectedAction}" action?`
              )}
            </p>

            <div className="mb-3">
              <label htmlFor="actionReason" className="form-label">
                Reason <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                id="actionReason"
                className={`form-control ${showReasonError ? "is-invalid" : ""
                  }`}
                rows={3}
                value={actionReason}
                onChange={(e) => {
                  setActionReason(e.target.value);
                  setShowReasonError(false);
                }}
                placeholder="Enter reason here"
              />
              {showReasonError && (
                <div className="invalid-feedback">Reason is required.</div>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowConfirmModal(false);
                setActionReason("");
                setShowReasonError(false);
              }}
              className="d-flex align-items-center"
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={confirmAndExecute}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </>

      {personalDetailsAccordion([
        {
          title: "Personal Details",
          content: (
            <>
              <Row className="align-items-center mb-3">
                <Col md={9}>
                  <div className="form-floating" ref={dropdownRef}>
                    <input
                      type="text"
                      name="caseID"
                      className="form-control zipcodeDetailsOverlay"
                      placeholder="Case ID"
                      value={searchQuery1}
                      maxLength={100}
                      onChange={handleSearchChange1}
                      required
                      disabled={
                        isAddNewPatient ||
                        (!canEditCase && (!isEditable || view_Case)) ||
                        subjectIDToUpdate != null

                      }
                      autoComplete="off"
                    />
                    <label>
                      Enter Patient Details{" "}
                      <span style={{ color: "red" }}> *</span>
                    </label>

                    {/* Show dropdown only if toggle is OFF */}
                    {!isAddNewPatient && filteredResults1.length > 0 && (
                      <div className="dropdown-results">
                        <ul
                          className="list-group custom-scroll-list"
                          style={{
                            maxHeight: "225px",
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          {/* Sticky Header */}
                          <li className="list-group-item11 d-flex justify-content-between align-items-center fw-bold sticky-header">
                            <div className="col-5p"></div>
                            <div className="col-20p">Patient Account No</div>
                            <div className="col-20p">Patient Name</div>
                            <div className="col-10p">Case Type</div>
                            <div className="col-10p">DOB</div>
                            <div className="col-20p">QME Doctor</div>
                            <div className="col-15p">Claim No</div>
                          </li>

                          {/* Scrollable Rows */}
                          {filteredResults1.map((option, index) => (
                            <li
                              key={index}
                              className="list-group-item11 d-flex justify-content-between align-items-evenly"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSelect1(option)}
                            >
                              <div className="col-5p">
                                <input
                                  type="radio"
                                  name="location"
                                  checked={
                                    selectedOption1?.subjectSSN ===
                                    option.subjectSSN
                                  }
                                  onChange={() => handleSelect1(option)}
                                />
                              </div>
                              <div className="col-20p">
                                {option.patientAccountNo || ""}
                              </div>
                              <div className="col-20p">
                                {`${option.lastName}, ${option.firstName} ${option.middleName ?? ""
                                  }`}
                              </div>
                              <div className="col-10p">
                                {option.caseType_ExamType || ""}
                              </div>
                              <div className="col-10p">
                                {option.subjectDob
                                  ? moment(option.subjectDob).format(
                                    "MM/DD/YYYY",
                                  )
                                  : ""}
                              </div>
                              <div
                                className="col-20p"
                                style={{ wordBreak: "break-all" }}
                              >
                                {option.qmeDoctorFullName || ""}
                              </div>
                              <div className="col-15p">
                                {option.claimNumber}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </Col>

                <Col md="3">
                  <Form.Check
                    type="switch"
                    id="add-new-patient-toggle"
                    label="Add a New Patient"
                    checked={isAddNewPatient}
                    onChange={() => {
                      const newValue = !isAddNewPatient;
                      setIsAddNewPatient(!isAddNewPatient);
                      setIsPatinetDetailsDisable(newValue);
                      setDob(null);
                      setQMEDoctor(null);
                    }}
                    className="mb-2"
                    disabled={!!subjectIDToUpdate}
                  />
                </Col>
              </Row>

              {isPatinetDetailsDisable && (
                <>
                  <Row>
                    <Col sm={3} className="selection_dropdown">
                      <SearchableSingleSelectDropdown
                        label="Saluation"
                        name="saluationId"
                        required
                        options={saluationOption}
                        value={saluation}
                        onChange={(e, name, value) => setSaluation(value)}
                        disabled={!canEditCase && (!isEditable || view_Case)}
                      />
                    </Col>

                    <Col sm={3}>
                      <TextInput
                        label="First Name"
                        name="firstname"
                        required={true}
                        value={firstName}
                        maxLength={50}
                        onChange={(e) => {
                          const value = e.target.value.replace(
                            /[^a-zA-Z ]/g,
                            "",
                          ); // Allow only alphabets and spaces
                          setFirstName(value.trimStart()); // Prevent initial spaces
                        }}
                        spacesTrim={true}
                        disabled={!canEditCase && (!isEditable || view_Case)}
                      />
                    </Col>
                    <Col sm={3}>
                      <TextInput
                        label="Middle Name"
                        name="middlename"
                        value={middleName}
                        maxLength={50}
                        onChange={(e) => {
                          const value = e.target.value.replace(
                            /[^a-zA-Z ]/g,
                            "",
                          );
                          // Prevent initial space
                          setMiddleName(value.trimStart());
                        }}
                        spacesTrim={true}
                        disabled={!canEditCase && (!isEditable || view_Case)}
                      />
                    </Col>
                    <Col sm={3}>
                      <TextInput
                        label="Last Name"
                        name="lastname"
                        required={true}
                        value={lastName}
                        maxLength={50}
                        onChange={(e) => {
                          const value = e.target.value.replace(
                            /[^a-zA-Z ]/g,
                            "",
                          );

                          setLastName(value.trimStart());
                        }}
                        spacesTrim={true}
                        disabled={!canEditCase && (!isEditable || view_Case)}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col sm={3}>
                      <TextInput
                        label="AKA"
                        name="aka"
                        value={aka}
                        maxLength={50}
                        onChange={(e) => {
                          let value = e.target.value;

                          // Prevent initial space
                          if (value.startsWith(" ")) return;

                          // Replace multiple spaces with a single space
                          value = value.replace(/\s{2,}/g, " ");
                          setAKA(value);
                        }}
                        disabled={!canEditCase && (!isEditable || view_Case)}
                      />
                    </Col>
                    <Col sm={3} ref={dropdownRef}>
                      <FloatingLabelDatepicker
                        label="Date of Birth"
                        name="dob"
                        value={dob} // Pass Date object
                        maxDate={today} // Prevents selecting future dates
                        showInfo={true}
                        infoMessage="Date of Birth is not selected"
                        onChange={(date: Date | null) => {
                          setDob(date); // Store Date object in state
                        }}
                        // required
                        dateFormat="MM/dd/yyyy"
                        disabled={!canEditCase && (!isEditable || view_Case)}
                      />
                    </Col>
                    <Col sm={3} className="selection_dropdown">
                      <SearchableSingleSelectDropdown
                        label="Gender"
                        name="genderId"
                        required
                        options={genderOption}
                        value={gender}
                        onChange={(e, name, value) => setGender(value)}
                        disabled={!canEditCase && (!isEditable || view_Case)}
                      />
                    </Col>
                    <Col sm={3}>
                      <TextInput
                        label="Social Security Number (SSN)"
                        name="ssnID"
                        value={
                          isSSNFocused
                            ? ssnNumber
                            : ssnNumber.length === 11
                              ? `XXX-XX-${ssnNumber.slice(-4)}`
                              : ssnNumber
                        }
                        maxLength={11}
                        onChange={handleSSNChange}
                        onFocus={unmaskSSN}
                        onBlur={() => {
                          setIsSSNFocused(false);
                          maskSSN();
                        }}
                        // required
                        disabled={!canEditCase && (!isEditable || view_Case)}
                      />
                    </Col>
                  </Row>
                </>
              )}
              <Row className="mt-3">
                <Col sm={3} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="QME Doctor"
                    name="QMEDoctor"
                    required
                    options={QMEDoctorOptions}
                    value={QMEDoctor}
                    onChange={(e, name, value) => {
                      setQMEDoctor(value);
                      const selectedDoctor = QMEDoctorOptions?.find(
                        (doctor) => doctor.value === value,
                      );
                      if (selectedDoctor) {
                        const SpecilizationInfo = extractSpecialization(
                          selectedDoctor?.contactFullName,
                        );
                        setSpecialization(SpecilizationInfo || "");
                      }
                    }}
                    disabled={!canEditCase && (!isEditable || view_Case)}
                  />
                </Col>

                {/* {specialization && 
                <Col sm={3}>
                  <TextInput
                    label="Specialization"
                    name="specialization"
                    value={specialization}
                    onChange={(e) => {
                      setSpecialization(e.target.value);
                    }}
                    disabled
                  />
                </Col>} */}
              </Row>
            </>
          ),
        },
      ])}
      {employementDetailsAccordion([
        {
          title: "Employer Details",
          content: (
            <>
              <Row className="mb-3">
                <Col sm={4} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="Employer"
                    name="employerId"
                    required
                    options={employerOption}
                    value={employee}
                    onChange={(e, name, value) => {
                      setEmployee(value);
                      setAddress(""); // Clear Address when Employer changes
                      setContact(""); // Clear Contact when Employer changes
                    }}
                    disabled={!canEditCase && (!isEditable || view_Case)}
                  />
                </Col>
                <Col sm={4} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="Address"
                    name="employeAddress"
                    // required
                    options={employerAddressOption}
                    value={address}
                    onChange={(e, name, value) => setAddress(value)}
                    disabled={
                      !canEditCase && (!employee || !isEditable || view_Case)
                    }
                  />
                </Col>
                <Col sm={4} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="Contacts"
                    name="contactsID"
                    // required
                    options={employerContactOption}
                    value={contact}
                    onChange={(e, name, value) => setContact(value)}
                    disabled={
                      !canEditCase && (!employee || !isEditable || view_Case)
                    }
                  />
                </Col>
              </Row>

              <Row className="mb-3 mt-3">
                <Col sm={6} className="d-flex justify-content-start">
                  {canEditCase || isEditable ? (
                    <Button
                      variant="primary"
                      className="d-flex align-items-center me-auto"
                      onClick={() => openDrawerWithType(PARTY_TYPES.EMPLOYER)}
                      disabled={view_Case || isStageNonEditable}
                    >
                      <span className="material-symbols-outlined">
                        add_circle
                      </span>
                      Add New Employer
                    </Button>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              {subjectIDToUpdate && (
                <>
                  {employmentdetailsubAccordion([
                    {
                      title: "Details",
                      content: (
                        <>
                          <div>
                            <Row>
                              <Col sm={3} className="d-flex align-items-center">
                                <span className="material-icons m-2 text-secondary">
                                  person
                                </span>
                                Employer
                              </Col>
                              <Col sm={3} className="d-flex align-items-center">
                                <span className="material-icons mx-2 text-secondary">
                                  account_balance
                                </span>
                                Employer Address
                              </Col>
                              <Col sm={6} className="d-flex align-items-center">
                                <span className="material-icons mx-2 text-secondary">
                                  restart_alt
                                </span>
                                Employer Contacts
                              </Col>
                            </Row>

                            <EmployerDetailsCard
                              employerDetails={employerDetails}
                            />
                          </div>
                        </>
                      ),
                    },
                  ])}
                </>
              )}
            </>
          ),
        },
      ])}

      {showForm && (
        <>
          {subjectadressAccordion([
            {
              title: "Patient Address",
              content: (
                <>
                  <Row className="row mb-3 ">
                    <Col md={3} className="selection_dropdown adj_label_lt">
                      <SearchableSingleSelectDropdown
                        label="Address Type"
                        name="AddressTypeID"
                        required
                        options={addressOption}
                        value={addressType} // Keep it a string if required
                        onChange={(e) => setAddressType(e.target.value)}
                        disabled={
                          !canEditCase &&
                          (!subjectIDToUpdate ||
                            view_Case ||
                            isStageNonEditable)
                        }
                      />
                    </Col>
                    <Col md={9}>
                      <SearchHospitalAutosuggest
                        value={searchQuery}
                        onChange={setSearchQuery}
                        onSuggestionSelect={handleSuggestionSelect}
                        label="Search Address"
                        maxLength={50}
                        disabled={
                          !canEditCase &&
                          (!subjectIDToUpdate ||
                            view_Case ||
                            isStageNonEditable)
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="row mb-2">
                    <Col md={6}>
                      <TextInput
                        label="Address Line 1"
                        name="AddressLine1"
                        value={addressline1}
                        required
                        maxLength={100}
                        onChange={(e) => setAddressLine1(e.target.value)}
                        disabled={
                          !canEditCase &&
                          (!subjectIDToUpdate ||
                            view_Case ||
                            isStageNonEditable)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <TextInput
                        name="AddressLine2"
                        label="Address Line 2"
                        value={addressline2}
                        maxLength={100}
                        onChange={(e) => setAddressLine2(e.target.value)}
                        disabled={
                          !canEditCase &&
                          (!subjectIDToUpdate ||
                            view_Case ||
                            isStageNonEditable)
                        }
                      />
                    </Col>
                  </Row>
                  <Row className="row mb-3 mt-3">
                    <Col md={6}>
                      <TextInput
                        name="AddressLine3"
                        label="Address Line 3"
                        value={addressline3}
                        maxLength={100}
                        onChange={(e) => setAddressLine3(e.target.value)}
                        disabled={
                          !canEditCase &&
                          (!subjectIDToUpdate ||
                            view_Case ||
                            isStageNonEditable)
                        }
                      />
                    </Col>
                  </Row>
                  <Row className="row mb-3">
                    {["City", "State", "Country", "Zip"].map((field) => {
                      const value =
                        addressDetails[
                        field.toLowerCase() as keyof typeof addressDetails
                        ];

                      const isDisabled = !suggestionSelected || !!suggestionFilled[field.toLowerCase() as keyof typeof suggestionFilled];
                      return (
                        <Col md={3} key={field}>
                          <TextInput
                            label={field}
                            name={field}
                            value={value}
                            maxLength={field === "State" && !isDisabled ? 3 : field === "Zip" && !isDisabled ? 10 : 100}
                            required
                            onChange={(e) => {
                              const newValue = field === "Zip" ? e.target.value.replace(/\D/g, "") : e.target.value;
                              setAddressDetails((prev: any) => ({ ...prev, [field.toLowerCase()]: newValue }));
                            }}
                            disabled={isDisabled}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                  <Row className="mb-3 mt-3">
                    <div className="mt-1 mb-3">
                      <label htmlFor="isActive" className="me-2 fw-bold">
                        Is Primary Address
                      </label>
                      <input
                        type="checkbox"
                        checked={isPrimaryAddress}
                        onChange={(e) => setPrimaryAddress(e.target.checked)}
                        className="form-check-input me-2"
                        disabled={
                          !canEditCase &&
                          (!subjectIDToUpdate ||
                            view_Case ||
                            isStageNonEditable)
                        }
                      />
                      {isPrimaryAddress ? <span>Yes</span> : <span>No</span>}
                    </div>
                  </Row>

                  <div className="border mt-3 mb-3">
                    <Row className="align-items-center">
                      <Col>
                        <h5 className="sectionTitle detailsubsection">
                          Communication Details
                        </h5>
                      </Col>
                    </Row>
                    <Row className="m-2">
                      <Col sm={6}>
                        <TagComponent
                          label="Phone No"
                          value={phoneNumber}
                          onChange={(newValues) =>
                            setPhoneNumber(newValues.map(String))
                          }
                          disabled={
                            !canEditCase &&
                            (!subjectIDToUpdate ||
                              view_Case ||
                              isStageNonEditable)
                          }
                          required={true}
                          isPhoneOrFax={true}

                        />
                      </Col>
                      <Col sm={6}>
                        <TagComponent
                          label="Fax No"
                          value={faxNumber}
                          onChange={(newValues) =>
                            setFaxNumber(newValues.map(String))
                          }
                          disabled={
                            !canEditCase &&
                            (!subjectIDToUpdate ||
                              view_Case ||
                              isStageNonEditable)
                          }
                          isPhoneOrFax={true}

                        />
                      </Col>
                      <Col sm={6} className="mt-3 mb-2">
                        <TagComponent
                          label="Email Address"
                          value={emailAddress}
                          onChange={setEmailAddress}
                          disabled={
                            !canEditCase &&
                            (!subjectIDToUpdate ||
                              view_Case ||
                              isStageNonEditable)
                          }
                          showInfo={true}
                          infoMessage="Email Address is not selected"
                        // required={true}
                        />
                      </Col>
                    </Row>
                  </div>

                  <Row className="mt-1">
                    <Col
                      sm={12}
                      className="d-flex justify-content-end align-items-center"
                    >
                      {/* Pushes this button to the extreme left */}

                      {showForm && (
                        <Button
                          variant="outline-info"
                          className="d-flex align-items-center"
                          onClick={cancelAddressForm}
                        //disabled={!isEditable || view_Case}
                        >
                          <span className="material-icons mr-2">close</span>{" "}
                          Cancel
                        </Button>
                      )}

                      {showForm && (
                        <Button
                          onClick={handleSaveAddress}
                          variant="primary"
                          className="ms-3 d-flex align-items-center"
                          disabled={
                            isSaving ||
                            !subjectIDToUpdate ||
                            view_Case ||
                            isStageNonEditable
                          }
                        >
                          <span className="material-icons mx-1">save</span> Save
                        </Button>
                      )}
                    </Col>
                  </Row>
                </>
              ),
            },
          ])}
        </>
      )}

      {subjectIDToUpdate &&
        !showForm &&
        addressDetailsAccordion([
          {
            title: "Address Details",
            content: (
              <>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3">
                  <h3 className="mr-2 me-auto">List</h3>
                  {subjectIDToUpdate && !showForm ? (
                    <Button
                      // variant="outline-info"
                      className="d-flex align-items-center mb-1"
                      onClick={handleAddContact}
                      disabled={
                        !canEditCase && (view_Case || isStageNonEditable)
                      }
                    >
                      <span className="material-icons mr-2">add</span> Add
                    </Button>
                  ) : null}
                </div>

                <DataTableAddress
                  headers={SUBJECT_ADDRESS}
                  rows={gridAddressData}
                  onAction={handleRowAction}
                />
              </>
            ),
          },
        ])}

      <Row className="mb-3 mt-3">
        <Col sm={6} className="d-flex justify-content-start">
          {userData?.caseInfoId ? (
            <Button
              variant="outline"
              className="btn d-flex align-items-center btn-text-border"
              onClick={handleNavigationBack}
            >
              <span className="material-icons mr-1">arrow_back</span>
              Back
            </Button>
          ) : (
            ""
          )}

          {subjectIDToUpdate ? (
            <OverlayTrigger
              show={showTooltip}
              placement="auto"
              trigger={["hover", "focus"]} // Important to prevent sticky tooltip
              delay={{ show: 200, hide: 100 }}
              overlay={
                <Tooltip style={{ backgroundColor: "#b3e0ff" }}>Logs</Tooltip>
              }
            >
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center mx-2"
                onClick={handlePDFClick}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <span className="material-icons">description</span>
              </button>
            </OverlayTrigger>
          ) : null}
        </Col>

        {activeKey == "0" || employementKey == "0" ? (
          <Col sm={6} className="d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={handleCancel}
              // disabled={!hasChanges()}
              disabled={!canEditCase && (!isEditable || view_Case)}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleSaveInfo}
              variant="primary"
              className="ms-3 d-flex align-items-center"
              disabled={
                isSaving || (!canEditCase && (!isEditable || view_Case))
              }
            >
              <span className="material-icons mx-1">save</span>
              {isSaving ? "Save" : "Save"}
            </Button>
          </Col>
        ) : null}
      </Row>

      <OverlayDrawer
        title={"Logs"}
        open={showLogDrawer}
        onClose={handleCloseLogDrawer}
        placement="bottom"
      >
        <DataTable
          headers={SUBJECT_LOG_HEADERS}
          rows={addressLogDetails}
          isLogTable={true}
        />
      </OverlayDrawer>
      {/* <Row className="mt-3 align-items-center"></Row>
      <Row className="mt-3 align-items-center"></Row>
      <Row className="mt-3 align-items-center"></Row> */}
      <NewPartiesDrawer
        title={"Party"}
        open={showDrawer}
        onClose={handlePartyDrawerClose}
        placement="end"
      >
        <AddNewPartyClient
          partyTypes={partyType}
          setPartyID={setPartyHeaderID}
          setHasAddressData={setHasAddressData}
          setHasContactData={setHasContactData}
          onBack={handlePartyDrawerClose}
        />
      </NewPartiesDrawer>

      <Modal show={showPartyModal} onHide={handlePartyCloseModal}>
        <Modal.Body className="fw-bold text-left modelheading">
          <div>
            {!hasAddressData && !hasContactData
              ? "You haven't filled Address and Contact details. Are you sure you want to cancel the form?"
              : !hasAddressData
                ? "You haven't filled Address details. Are you sure you want to cancel the form?"
                : !hasContactData
                  ? "You haven't filled Contact details. Are you sure you want to cancel the form?"
                  : "Are you sure you want to cancel the form?"}
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-center"
            onClick={handlePartyCloseModal}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handlePartyConfirmCancel}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Case_Subject;
